import { Alert } from "react-bootstrap";
import { FaTrash } from "react-icons/fa";

import TimeDisplay from "../TimeDisplay/index.jsx";

export default function MeasurementDeletedAlert({
    deletedTimestamp,
    organizationId,
    locationId,
    className,
    deletedText = "This measurement was deleted at",
}) {
    return (
        <Alert variant="danger" className={className}>
            <FaTrash className="me-2" />
            {`${deletedText} `}
            <TimeDisplay
                timestamp={deletedTimestamp?.seconds}
                format="YYYY-MM-DD HH:mm:ss"
                organizationId={organizationId}
                locationId={locationId}
            />
        </Alert>
    );
}
